<div *ngIf="mapdata">
    <ngx-charts-bar-vertical
    [view]="[500, 400]"
    [scheme]="colorScheme"
    [results]="mapdata"
    [xAxis]="true"
    [yAxis]="true"
    [showXAxisLabel]="true"
    [showYAxisLabel]="true"
    [xAxisLabel]="'Month'"
    [yAxisLabel]="'Water dispense Sum (Ltr)'"
    (select)="onSelect($event)">
    </ngx-charts-bar-vertical>
</div>
